import { createEvent, createStore } from 'effector'

export function createModalModel() {
  const modalOpened = createEvent<void | object>()
  const modalClosed = createEvent()
  const $isModalOpened = createStore(false)
    .on(modalOpened, () => {
      return true
    })
    .on(modalClosed, () => false)
  return {
    $isModalOpened,
    modalOpened,
    modalClosed,
  }
}
